import React, { forwardRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import { Colors } from '../../../colors';
import { CalendarStyled } from './calendar.styled';
import allLocales from '@fullcalendar/core/locales-all';
import moment from 'moment/moment';

const ONE_DAY = 1;

export interface CalendarProps {
  onDaySelect?: (info: any) => void;
  onEventClick?: (event: any) => void;
  renderEventContent: (event: any) => void;
  events?: any;
  reference: any;
  onMonthChange: (event: any) => void;
  selectable?: boolean
}
const Calendar = forwardRef((props: CalendarProps, ref) => {

  const {selectable = true} = props

  return (
    <CalendarStyled.Container>
      <FullCalendar
        selectAllow={(info) => {
          let dateStart = moment(info.start, 'YYYY-MM-DD HH:mm')
          let dateStartISOString : any = new Date(info.start.setDate(info.start.getDate() + ONE_DAY)).toISOString();
          let dateEnd = info.end;
          let dateEndISOString = dateEnd.toISOString()
          if (dateStartISOString !== dateEndISOString || dateStart.isBefore(moment().subtract(1, 'days'))) {
            return false;
          }
          return true;
        }}
        selectable={selectable}
        selectLongPressDelay={0}
        locales={allLocales}
        locale={'it'}
        ref={props.reference}
        headerToolbar={
          {
            left: 'prev,next',
            center: 'title',
            right: 'dayGridMonth'
          }
        }
        initialView={'dayGridMonth'}
        dateClick={props.onDaySelect}
        eventClick={props.onEventClick}
        eventContent={props.renderEventContent}
        displayEventEnd={true}
        displayEventTime={true}
        selectMirror
        dayMaxEvents
        themeSystem="Simplex"
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
        events={props.events}
        height={'auto'}
        eventBackgroundColor={Colors.White}
        datesSet={event => {
          props.onMonthChange(event)
        }}
        eventDisplay={'list-item'}

      />
    </CalendarStyled.Container>
  );
});

export default Calendar;
